import team from './team';
import services from './services';
import blogs from './blogs';
import products from './products';
import projects from './projects';
import events from './events';
import courses from './courses';
import donations from './donations';
import { positions }  from './career';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Donation'},
        subLink: [
            { id: 1, link: "/Donations", title: "Donations" },
            { id: 2, link: "/Donations/Donation-Single", title: "Donation Single",  state: donations[0] },
            { id: 3, link: "/Donation-Form", title: "Donate Now" },
            { id: 4, link: "/Donation-Confirmation", title: "Donation Confirmation" },
        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'Event'},
        subLink: [
            { id: 1, link: "/Events", title: "Events" },
            { id: 2, link: "/Events/Event-Single", title: "Event Single",  state: events[0] },
        ],
    },
    {
        id: 6,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery" },
            {
                id: 2,
                title: "Course",
                children: [
                    { id: 1, link: "/Courses", title: "Courses" },
                    { id: 2, link: "/Courses/Course-Single", title: "Course Single", state: courses[0] },
                ],
            },
            {
                id: 3,
                title: "Project",
                children: [
                    { id: 1, link: "/Projects", title: "Projects" },
                    { id: 2, link: "/Projects/Project-Single", title: "Project Single", state: projects[0] },
                ],
            },
                        {
                id: 4,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single", state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
        {
                id: 5,
                title: "Information Hub",
                children: [
                    { id: 1, link: "*", title: "Error 404" },
                    { id: 2, link: "/Services-Terms", title: "Terms of Services" },
                    { id: 3, link: "/Privacy-Policy", title: "Privacy Policy" },
                ],
            },
            { id: 6, link: "/Prayer-Timings", title: "Prayer Timings" },
            { id: 7, link: "/Video-Library", title: "Video Library" },
            { id: 8, link: "/Sponsors", title: "Sponsors" },
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 8,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 9,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;